// removed by extract-text-webpack-plugin
module.exports = {"root":"_24x47","separator":"EtCS6","link":"XdzWJ","list":"_3Lgx0","name":"-WPmO"};